// React & Hooks
import { useState, useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";

// Material UI Components
import { Box, Stack, Button, Fade } from "@mui/material";

// Contexts
import { AuthContext } from "../../Context/AuthContext";

// Custom Hooks
import useGetClassById from "../../Hooks/useGetClassById";
import useGetStudentById from "../../Hooks/useGetStudentById";

// UI Components
import { PageHeaderTitle } from "../../Utils/Component";

// Page Styles
import "../../Style/pagestyle.scss";

// Feature Components
import Homework from "./HomeworkForStudent/HomeworkForStudent";
import TeachingTime from "./TeachingTimeForStudent/TeachingTimeForStudent";

export default function StudyClassDetailForStudent() {
  // Translation context
  const { t } = useContext(AuthContext);

  const ifTab = ["Homework", "TeachingTime"].includes(
    window.localStorage.getItem("student_tab")
  );
  // Read tab from localStorage or set default
  const handleGetItemTabFromLocalStorage = () => {
    return ifTab ? window.localStorage.getItem("student_tab") : "Homework";
  };

  const [tab, setTab] = useState(
    handleGetItemTabFromLocalStorage() || "Homework"
  );

  // Get classId from query parameters
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const classId = params.get("classId");
  const studentId = params.get("studentId");

  // Fetch class data
  const { classData } = useGetClassById({ id: classId });
  const { studentData } = useGetStudentById({ id: studentId });

  // Persist tab selection to localStorage
  useEffect(() => {
    window.localStorage.setItem("student_tab", tab);
  }, [tab]);

  // Mapping tabs to components
  const TabComponents = {
    Homework,
    TeachingTime,
  };

  const ActiveComponent = TabComponents[tab];

  // Props passed to each tab component
  const tabPropsMap = {
    Homework: { classId, studentId },
    TeachingTime: { classId, studentId },
  };

  const activeProps = tabPropsMap[tab] || {};

  // Tab button definitions
  const tabs = [
    { key: "Homework", label: t("thead_homework") },
    { key: "TeachingTime", label: t("thead_teaching_time") },
  ];

  return (
    <div className="page-container">
      <PageHeaderTitle
        classPage={t("class-page-title")}
        classSlash="slash-title"
        routeTo={`/student/student-detail?studentId=${studentId}`}
        pageTitle={
          classData?.courseId?.enName
            ? classData?.courseId?.enName + " " + classData?.className
            : ""
        }
        detailTitle={studentData?.familyName + " " + studentData?.studentName}
      />
      <Stack direction="column" spacing={2}>
        <Box>
          {/* Tab Navigation */}
          <Box
            className="tab-container"
            sx={{ position: "relative", marginTop: 8 }}
          >
            <Box sx={{ position: "absolute", bottom: "-2px", width: "100%" }}>
              <Stack
                direction="row"
                alignItems="flex-end"
                justifyContent="space-between"
                sx={{ width: "100%" }}
              >
                <Stack direction="row" className="tab">
                  {tabs.map(({ key, label }) => (
                    <Button
                      key={key}
                      className={
                        tab === key
                          ? t("class-name-tab-item-active")
                          : t("class-name-tab-item")
                      }
                      onClick={() => setTab(key)}
                    >
                      {label}
                    </Button>
                  ))}
                </Stack>
              </Stack>
            </Box>
          </Box>
        </Box>
        {/* Tab Content with Fade Transition */}
        <Box>
          <Fade in={true} key={tab} timeout={400}>
            <div>{ActiveComponent && <ActiveComponent {...activeProps} />}</div>
          </Fade>
        </Box>
      </Stack>
    </div>
  );
}
